import { render, staticRenderFns } from "./CredInBulk.vue?vue&type=template&id=dc12b5f4"
import script from "./CredInBulk.vue?vue&type=script&lang=js"
export * from "./CredInBulk.vue?vue&type=script&lang=js"
import style0 from "./CredInBulk.vue?vue&type=style&index=0&id=dc12b5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports